import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@mui/material'
import useStyles from './SelectField.style'

const SelectField = ({
  dataId = null, styleClass = null, label, value, handleValue, arrayOfValues, disabled = false,
}) => {
  const { classes } = useStyles()

  return (
    <TextField
      disabled={disabled}
      select
      label={label}
      value={value}
      onChange={handleValue}
      SelectProps={{
        native: true,
      }}
      InputProps={{ className: classes.select, 'data-id': dataId }}
      variant="standard"
      className={styleClass}
    >
      {arrayOfValues.map((option) => (
        <option key={option.value} value={option.value}>
          {option.title}
        </option>
      ))}
    </TextField>
  )
}

SelectField.propTypes = {
  // Defaults provided via destructuring parameters (avoids deprecated FC defaultProps).
  // eslint-disable-next-line react/require-default-props
  dataId: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  styleClass: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  handleValue: PropTypes.func.isRequired,
  arrayOfValues: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line react/require-default-props
  disabled: PropTypes.bool,
}

export default SelectField
